import { Component, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EventEmitter } from '@angular/core';
import { ModalPopupType } from '../../models/modalPopupType';

@Component({
    standalone: false,
    selector: 'app-modal-delete-popup',
    templateUrl: './modal-delete-popup.component.html',
    styleUrls: ['./modal-delete-popup.component.css']
})
export class ModalDeletePopupComponent implements OnInit {

    @ViewChild('template') template: TemplateRef<any>;
    @Output() clickedYes = new EventEmitter<any>();
    @Output() clickedCancel = new EventEmitter<any>();
    @Input() message: string;
    @Input() submessage: string;
    @Input() customYesText: string;
    @Input() customNoText: string;
    modalType: ModalPopupType;
    modalRef: BsModalRef;
    deleteuserIds: number[] = [];
    config = {
        animated: true,
        class: 'modal-dialog-centered'
    };

    constructor(private bsModalService: BsModalService) { }

    ngOnInit(): void {
    }

    show() {
        this.modalRef = this.bsModalService.show(this.template, this.config)
    }

    yes() {
        this.clickedYes.emit(this.deleteuserIds);
        this.modalRef.hide();
    }

    cancel() {
        this.modalRef.hide();
    }
    
   close(): void {
        this.modalRef?.hide();
    }
    open(): void {
        this.modalRef = this.bsModalService.show(this.template, this.config);
    }
}
